import React from 'react'

import { InformationScreenType } from '@ally/transmitigator'
import { LegacyOBSA } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'

export const OBSAWrapper: React.FC = () => {
  const { activeScreen, hostServices } = useTransmit()

  if (activeScreen.type !== InformationScreenType.OBSA) {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <LegacyOBSA {...activeScreen.payload} hostServices={hostServices} />
}
